module.exports = __webpack_public_path__ + "static/media/state2023.1aa478c7.jpeg";